import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./index.css";

const ComingSoonPage = () => {
  return (
    <div className="vertical-center">
      <Container>
        <Row className="justify-content-center">
          <Col md={6} className="text-center">
            <h1>⏳</h1>
            <h2>Coming Soon</h2>
            <Button variant="secondary" href="/">
              Back to Homepage
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ComingSoonPage;
